import { createFormControl, useFormState } from 'react-hook-form';
import { CreateApplicationFormDataValues } from './schema';
import { useMemo } from 'react';
import { useCreateApplicationFormOnSubmitFactory } from './onSubmit';
import { MarketCountryCode } from '@axo/shared/types';

const formControls: Record<
  string,
  ReturnType<typeof createFormControl<CreateApplicationFormDataValues>>
> = {};

export const getCreateApplicationFormContext = (
  marketCountry: MarketCountryCode,
) => {
  if (!formControls[marketCountry])
    formControls[marketCountry] = createFormControl();

  return formControls[marketCountry];
};

export const useCreateApplicationFormContext = (
  marketCountry: MarketCountryCode,
) => {
  const formContext = getCreateApplicationFormContext(marketCountry);
  const submit = useCreateApplicationFormOnSubmitFactory({
    formContext,
  });

  const formState = useFormState({ control: formContext.control });

  return useMemo(
    () => ({
      ...formContext,
      formState,
      handleSubmit: undefined,
      submit,
    }),
    [submit, formState, formContext],
  );
};
